
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export function AboutCreator() {
  return (
    <footer className="w-full py-4 bg-background border-t">
      <div className="container text-center text-sm text-muted-foreground">
        <Dialog>
          <DialogTrigger className="hover:underline">
            About the Creator
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle className="mb-4">About the Creator</DialogTitle>
              <DialogDescription className="space-y-4 text-left">
                <p>
                  I'm an Old Coach enthusiast looking to share resources in new, convenient ways. 
                  To further support me, you can subscribe to my YouTube{" "}
                  <a 
                    href="https://www.youtube.com/@OldCoachCleaning" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    @OldCoachCleaning
                  </a>{" "}
                  or check out the bags I have listed on{" "}
                  <a 
                    href="https://oldcoachcleaning.etsy.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    oldcoachcleaning.etsy.com
                  </a>
                </p>
                
                <p>
                  Much of the data for this site was provided in a spreadsheet by Reddit user{" "}
                  <a 
                    href="https://www.reddit.com/user/abbythestabby/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    @abbythestabby
                  </a>
                  , whose contributions to{" "}
                  <a 
                    href="https://www.reddit.com/r/VintageCoachRehab/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    r/VintageCoachRehab
                  </a>{" "}
                  are unrivaled and appreciated by all Old Coach lovers.
                </p>
                
                <p>
                  If you have questions or comments, please reach out to me via my YouTube or 
                  Etsy accounts.
                </p>
                
                <p>Love, Old Coach Cleaning</p>
              </DialogDescription>
            </DialogHeader>
          </DialogContent>
        </Dialog>
      </div>
    </footer>
  );
}
